import { useMemo } from 'react';
import { getIsTwilioBasedCallProvider } from 'calling-internal-common/utils/isThirdPartyCallingPopoverInUse';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ProviderName = ({
  selectedCallProvider
}) => {
  const name = useMemo(() => {
    return getIsTwilioBasedCallProvider(selectedCallProvider) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "callWidgetProviders.HubSpot.widgetTitle"
    }) : selectedCallProvider.name;
  }, [selectedCallProvider]);
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "400",
    paddingBlockStart: "300",
    paddingBlockEnd: "200",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: name
    })
  });
};
export default ProviderName;